module.exports = __webpack_public_path__ + "img/play.0027922a.png";